import { Form, FormLabel, InputGroup, Button, FormText } from "react-bootstrap";
import { useField } from "formik";
import { Fragment, memo } from "react";
import PhoneInput from "react-phone-input-2";
import Select from "react-select";
import "react-phone-input-2/lib/style.css";
import EditorToolbar, { formats, modules } from "./EditorToolbar";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { CircleMinus, Plus } from "lucide-react";
import TextareaAutosize from "react-textarea-autosize";
import Files from "react-files";
import { FixedSizeList as List } from "react-window";
import { toast } from "react-toastify";
import FileViewer from "./FileViewer";
import { ACCEPT_ALL_FORMAT } from "../data/StaticData";
import FormikErrorFocus from "formik-error-focus";
import RadioGroup from "./RadioGroup";
import {
  onlyDigitKey,
  onlyDecimalKey,
  handleDigitPaste,
  handleDecimalPaste,
} from "../utils/helper";

const MyInput = ({
  formikProps,
  label,
  isRequired = false,
  customType,
  dateProps,
  selectProps,
  inputStyle,
  containerStyle,
  rightElement,
  min,
  max,
  maxFileSize = 25000000,
  quilHeight = "100px",
  helperText = "",
  allowMultipleFile = false,
  isDisabled = false,

  ...props
}) => {


  const disableCertainFruit = (option) => {
    console.log("option", option)
    return option.is_end_user === true || option.is_supervisor === true
  };

  const [field, meta] = useField(props);
  const error = meta.touched && meta.error;
  console.log("selectProps", selectProps)

  console.log("props", props)

  const MenuList = ({ children, maxHeight }) => {
    const height = 35;
    const totalHeight = Math?.min(children?.length * height, maxHeight);

    if (!children?.length) {
      return <NoDataInList />;
    }

    return (
      <List height={totalHeight} itemCount={children?.length} itemSize={height}>
        {({ index, style }) => <div style={style}>{children[index]}</div>}
      </List>
    );
  };

  const NoDataInList = () => (
    <>
      {selectProps?.addMore && (
        <Button
          variant="outline-primary"
          className="w-100 mt-2"
          onClick={selectProps?.addMore}
        >
          <Plus size={15} /> Add New
        </Button>
      )}
      <div className="p-2 text-gray text-center">No Result</div>
    </>
  );

  const renderComponent = () => {
    switch (customType) {
      case "phone":
        return (
          <PhoneInput
            // countryCodeEditable={false}
            country={"in"}
            disableDropdown
            preferredCountries={["in"]}
            value={field.value}
            onChange={(phoneValue, country) => {
              formikProps.setFieldValue(field.name, `+${phoneValue}`);
            }}
            inputStyle={{
              width: "100%",
              background: "transparent",
              border: "0",
            }}
            {...props}
          />
        );

      case "select":
        const filteredValue = selectProps?.data?.filter((itm) =>
          props.multiple
            ? field?.value?.includes(itm.value)
            : itm?.value == field.value
        );
        return (
          <Select
            isMulti={props.multiple}
            menuPortalTarget={document.body}
            closeMenuOnSelect={!props?.multiple}
            value={props?.multiple ? filteredValue : filteredValue?.[0] || null}
            onChange={(selectedOption) => {
              if (selectProps?.onChange) {
                selectProps.onChange(selectedOption);
              }
              const value = props.multiple
                ? selectedOption.map((option) => option.value)
                : selectedOption?.value;
              formikProps.setFieldValue(field.name, value || "");
            }}
            options={selectProps?.data || []}
            isClearable
            classNamePrefix="react-select"
            isDisabled={isDisabled}
            isInvalid={error}
            placeholder="Select..."
            noOptionsMessage={() => <NoDataInList />}
            components={{ MenuList }}
            // isDisabled={selectProps?.getdisabled}
            isOptionDisabled={disableCertainFruit}

            {...props}
          />
        );

      case "multiline":
        return (
          <TextareaAutosize
            rows={2}
            minRows={2}
            className="edit-textarea"
            value={field.value}
            onChange={(val) =>
              formikProps.setFieldValue(field.name, val.target.value)
            }
            {...props}
          />
        );

      case "editor":
        return (
          <Fragment>
            <EditorToolbar shortId={props?.shortId || field.name} />
            <ReactQuill
              style={{ height: quilHeight }}
              modules={modules(props?.shortId || field.name)}
              formats={formats}
              theme="snow"
              value={field.value}
              onChange={(val) => formikProps.setFieldValue(field.name, val)}
            />
          </Fragment>
        );

      case "fileUpload":
        const handleFilesChange = (files) => {
          if (selectProps?.onChange) {
            selectProps.onChange(allowMultipleFile ? files : files[0]);
          }

          formikProps.setFieldValue(
            field.name,
            allowMultipleFile ? files : files[0]
          );
        };

        const handleRemoveFile = (index) => {
          const updatedFiles = allowMultipleFile
            ? field.value.filter((_, idx) => idx !== index)
            : null;
          formikProps.setFieldValue(field.name, updatedFiles);
        };

        const files = Array.isArray(field.value) ? field.value : [field.value];
        return (
          <>
            <div>
              {(allowMultipleFile ? field?.value?.length > 0 : field?.value) ? (
                <div
                  className="file-upload-container"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    gap: 10,
                  }}
                >
                  {files?.map((file, index) => (
                    <div
                      className="file-upload-item"
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        border: `1px solid gray`,
                        borderRadius: 1,
                        position: "relative",
                        padding: 5,
                      }}
                    >
                      <FileViewer className="file-viewer" file={file} />

                      <small>{file?.name || "Uploaded file"}</small>
                      <CircleMinus
                        size={20}
                        style={{
                          cursor: "pointer",
                          position: "absolute",
                          top: 0,
                          right: 0,
                          color: "red",
                          margin: "-10px",
                          background: "var(--bs-indigo)",
                          borderRadius: "50px",
                        }}
                        onClick={() => handleRemoveFile(index)}
                      />
                    </div>
                  ))}
                </div>
              ) : (
                <Files
                  className="files-dropzone"
                  onChange={handleFilesChange}
                  onError={(error) => toast.error(error.message)}
                  accepts={props?.accepts || ACCEPT_ALL_FORMAT}
                  multiple={allowMultipleFile}
                  maxFileSize={maxFileSize}
                  minFileSize={0}
                  clickable
                  {...props}
                >
                  <div
                    style={{
                      padding: "0.375rem 0.75rem",
                      border: `1px dashed rgba(0, 0, 0, 0.23)`,
                      borderRadius: 1,
                      backgroundColor: "#EEEEEE",
                      textAlign: "center",
                    }}
                  >
                    <p style={{ color: "gray" }} className="mb-0">
                      {field.value
                        ? `${field.value ? files?.length : 0} File${files?.length > 1 ? "s" : ""
                        } Selected`
                        : "Click to choose file or drag and drop here"}
                    </p>
                  </div>
                </Files>
              )}
            </div>
          </>
        );

      case "radio":
        return (
          <RadioGroup
            options={selectProps?.data}
            value={field.value}
            onChange={(val) => formikProps.setFieldValue(field.name, val)}
          />
        );


      default: {
        // Treat type="number" as a text input with manual key/paste filtering
        // so users can't enter letters or invalid characters while still
        // getting decimal support where needed. integerOnly disables the
        // decimal point for fields like phone, OTP, Aadhar, etc.
        const isNumberType = props.type === "number";
        const allowDecimal = props.integerOnly !== true;
        const { integerOnly, type: _ignoredType, onKeyPress: userKeyPress, onPaste: userPaste, ...restProps } = props;

        const handleKeyPress = isNumberType
          ? (e) => {
              if (allowDecimal) onlyDecimalKey(e);
              else onlyDigitKey(e);
              if (userKeyPress) userKeyPress(e);
            }
          : userKeyPress;

        const handlePaste = isNumberType
          ? (e) => {
              if (allowDecimal) handleDecimalPaste(e);
              else handleDigitPaste(e);
              if (userPaste) userPaste(e);
            }
          : userPaste;

        // Number inputs increment/decrement when the wheel scrolls while the
        // input has focus. Approvers reported accidental value changes while
        // scrolling the page. Blur on wheel so the page scrolls instead and
        // chain to any caller-provided onWheel handler.
        const handleWheel = isNumberType
          ? (e) => {
              e.target.blur();
              if (props.onWheel) props.onWheel(e);
            }
          : props.onWheel;

        // The caller's `type` is honoured here. It used to be destructured away
        // and dropped, so every type="date" / "email" / "password" / "month"
        // rendered as a plain text box — which is how free text such as
        // "23 AKSK" ended up saved in a loan date.
        const resolvedType = isNumberType
          ? "text"
          : _ignoredType || customType || "text";

        // min/step describe a numeric range. On a date input min="0" is not a
        // valid date and would be ignored at best, so they are only applied
        // where they mean something.
        const isRangeType = isNumberType || resolvedType === "range";

        return (
          <InputGroup>
            <Form.Control
              isInvalid={error}
              disabled={isDisabled}
              inputMode={isNumberType ? (allowDecimal ? "decimal" : "numeric") : undefined}
              {...field}
              {...restProps}
              type={resolvedType}
              onKeyPress={handleKeyPress}
              onPaste={handlePaste}
              {...(isRangeType ? { min: min || 0, step: "any" } : {})}
              {...(min && !isRangeType ? { min } : {})}
              {...(max ? { max } : {})}
              onWheel={handleWheel}
            />
          </InputGroup>
        );
      }
    }
  };

  return (
    <div style={containerStyle}>
      {label && (
        <FormLabel>
          {label} {isRequired && <span className="text-danger">*</span>}
        </FormLabel>
      )}
      {renderComponent()}
      {helperText && <FormText>{helperText}</FormText>}
      {error && <FormText className="text-danger">{meta.error}</FormText>}

      <FormikErrorFocus
        offset={0}
        align="top"
        focusDelay={200}
        ease="linear"
        duration={300}
      />
    </div>


  );
};

export default memo(MyInput);
